import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../Assets/LOGO_CFCAE.png';

const Presantation = () => {
	return (
		<div className='w-full flex flex-col items-center justify-start bg-white md:bg-transparent h-auto'>
			<div className='grid md:grid-cols-2 w-full md:w-[80%] p-6 bg-white h-full  md:p-12'>
				<img src={logo} alt='/' className='my-4 mx-auto w-[300px]' />
				<div className='justify-center flex flex-col gap-3'>
					{/* <h1 className='font-bold text-[#87152B]  py-2'>
						CFCAE
					</h1> */}
					<p>
						<span className='font-normal text-[#87152B] md:text-4xl sm:text-3xl text-2xl'>
							CFCAE
						</span>
							est un cabinet d’accompagnement sur le développement des entreprises industrielles  notamment dans le domaine électrique, à travers les diagnostics, expertises, conseils et  formations. 
							<br></br>
							Notre cabinet s’engage à vous apporter des solutions adaptées à vos besoins. En mobilisant toutes les ressources nécessaires à la réussite de vos projets et le développement de vos personnels. Nous sommes engagés à répondre à vos attentes et nous veillons à vous fournir des services qui apporteront une contribution pertinente à la réussite de vos projets. 
					</p>

					{/* <Link to='/plus'>
						<button className='bg-white border border-[#87152B] text-[#AC9961] hover:text-[#87152B] hover:bg-[#AC9961] hover:border-[#AC9961] transition-all ease-in-out duration-700 md:mx-0 mx-auto p-2 mt-4 font-medium  w-[150px] rounded-md'>
							Voire plus
						</button>
					</Link> */}
				</div>
			</div>
		</div>
	);
};

export default Presantation;
